import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/SearchPage.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/audio-guide',
    name: 'audioGuide',
    component: () => import(/* webpackChunkName: "audio" */ '../views/AudioGuideView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
